import type { DefaultValues } from 'react-hook-form';
import { queryString } from '@olivierpascal/helpers';
import { Stack } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import type { ILogInFormValues } from '~/components/forms/LogInForm';
import { LogInForm } from '~/components/forms/LogInForm';
import { Heading } from '~/components/molecules/Heading';
import { useNavigate } from '~/components/utils/Navigation';

export type INewSessionPageProps = {
  defaultValues?: DefaultValues<ILogInFormValues>;
  nextUrl?: string;
};

export const NewSessionPage: React.FC<INewSessionPageProps> = (props) => {
  const { defaultValues, nextUrl } = props;
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const previousUrlParam = searchParams.get('previousUrl') ?? undefined;
  const previousUrl = `^/sessions?${queryString.build({
    previousUrl: previousUrlParam,
  })}`;

  return (
    <>
      <Helmet>
        <title>{t('NewSessionPage.seo.title')}</title>
      </Helmet>

      <Heading title={t('NewSessionPage.title')} previousUrl={previousUrl} />

      <Stack gap={4}>
        <LogInForm
          defaultValues={defaultValues}
          onSuccess={(authorization) => {
            const next = nextUrl?.startsWith('/') ? nextUrl : '/';
            navigate(next, {
              appRegion: authorization.region,
            });
          }}
          cancelUrl={previousUrl}
        />
      </Stack>
    </>
  );
};
